import React from "react";

export default function SectionHead({
  id,
  eyebrow,
  title,
  text,
  className = "",
}) {
  return (
    <section
      id={id}
      className={`px-[5%] pt-16 text-center md:pt-20 lg:px-[8%] ${className}`.trim()}
    >
      <div className="party-boss-reveal mx-auto mb-10 max-w-4xl md:mb-14">
        <p className="text-sm font-black uppercase tracking-widest text-[#ffd166]">
          {eyebrow}
        </p>
        <h1 className="my-3 text-3xl font-black leading-tight md:text-4xl">
          {title}
        </h1>
        <p className="text-base leading-7 text-[#c9c1d9] md:text-[17px] md:leading-8">
          {text}
        </p>
      </div>
    </section>
  );
}
